import { react2angular } from 'react2angular';

import { AppointmentsPage } from './UpcomingBuyerShowings';

import BuyerAppointmentsPdf from './BuyerAppointmentsPdf';
import ManageAppointmentPage from './ManageAppointmentPage';
import CoopCancelAppointmentPage from './CoopCancelAppointmentPage';

// angular component
import bbInternalFeedbackComponent from './appointment_feedback/internal_feedback.component';
import bbInternalCoopTimeChangeComponent from './appoointment_time_change/internal_coop_time_change.component';

angular
  .module('bb.my_business', ['ngRoute'])
  .component(
    'appointmentsPage',
    react2angular(AppointmentsPage, [], ['$routeParams']),
  )
  .component(
    'buyerAppointmentsPdf',
    react2angular(BuyerAppointmentsPdf, [], ['$location']),
  )
  .component(
    'manageAppointmentPage',
    react2angular(
      ManageAppointmentPage,
      [],
      ['$scope', '$routeParams', '$rootScope', '$location', 'ToastService'],
    ),
  )
  .component(
    'coopCancelAppointmentPage',
    react2angular(
      CoopCancelAppointmentPage,
      [],
      ['$scope', '$routeParams', '$rootScope', '$location', 'ToastService'],
    ),
  )
  // angular component
  .component('bbInternalFeedback', bbInternalFeedbackComponent)
  .component('bbInternalCoopTimeChange', bbInternalCoopTimeChangeComponent);

require('../external/VirtualTourDetails/virtual_tour_details.module');

require('./my_business.routes');
require('./my_business.service');

require('./action_required/action_required_detail.component');
